var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenchecked(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10,
    fill: "#FAFCF6",
    stroke: "#A9CF4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3431 8.64349L10.2655 13.7181C9.88948 14.094 9.27955 14.094 8.90319 13.7181L6.28211 11.0982C5.90596 10.7223 5.90596 10.1126 6.28211 9.73666C6.65832 9.36064 7.26821 9.36064 7.64426 9.73652L9.58454 11.6758L13.9807 7.28191C14.3569 6.90589 14.9669 6.90617 15.3429 7.28191C15.719 7.65786 15.719 8.26733 15.3431 8.64349Z",
    fill: "#A9CF4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenchecked);
export default __webpack_public_path__ + "static/media/Greenchecked.e7fa0a56eaa28604211acba1031f7188.svg";
export { ForwardRef as ReactComponent };